import Dayjs from 'dayjs';

/**
 * 检查手机号
 * */
export function isMobilePhone(phone) {
  //const reg = /^((1[3,5,8][0-9])|(14[5,7,9])|(17[0,1,3,5,6,7,8]))\d{8}$|^852[5,6,9]\d{7}$/;
  const reg = /^1[0|1|2|3|4|5|6|7|8|9][0-9]{9}$/;
  return reg.test(phone);
}

export function phone(phone) {
  const reg = /^((1[3,5,8][0-9])|(14[5,7,9])|(17[0,1,3,5,6,7,8]))\d{8}$|^852[5,6,9]\d{7}$/;
  return reg.test(phone);
}

export function name(name) {
  const reg = /^\S{1,10}$/;
  return reg.test(name);
}

/**
 * 检查验证码合法性
 * 数字,大于4位
 * */
export function isVerifyCode(code) {
  return code.length >= 4;
}

/**
 * 检查密码合法性
 * 长度大于6
 * */
export function isVerifyPassWord(psw) {
  return psw.length >= 6;
}

/**
 检查姓名是否为中文
 字数2～20个（含符号）
 UTF-8字符集
 只允许汉字和 . ·  （少数民族名字中含有,如："努尔麦麦提·卡卡西"）
 name：要检查的姓名字符串
 */
export function isChineseName(name) {
  var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,20}[·.]?[\u4E00-\u9FA5\uf900-\ufa2d]{0,20}$/;
  return reg.test(name) && name.length <= 20;
}

/**
 身份证认证：

 根据〖中华人民共和国国家标准 GB 11643-1999〗中有关公民身份号码的规定，公民身份号码是特征组合码，由十七位数字本体码和一位数字校验码组成。排列顺序从左至右依次为：六位数字地址码，八位数字出生日期码，三位数字顺序码和一位数字校验码。
 地址码表示编码对象常住户口所在县(市、旗、区)的行政区划代码。
 出生日期码表示编码对象出生的年、月、日，其中年份用四位数字表示，年、月、日之间不用分隔符。
 顺序码表示同一地址码所标识的区域范围内，对同年、月、日出生的人员编定的顺序号。顺序码的奇数分给男性，偶数分给女性。
 校验码是根据前面十七位数字码，按照ISO 7064:1983.MOD 11-2校验码计算出来的检验码。

 出生日期计算方法。
 15位的身份证编码首先把出生年扩展为4位，简单的就是增加一个19或18,这样就包含了所有1800-1999年出生的人;
 2000年后出生的肯定都是18位的了没有这个烦恼，至于1800年前出生的,那啥那时应该还没身份证号这个东东，⊙﹏⊙b汗...
 下面是正则表达式:
 出生日期1800-2099  (18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])
 身份证正则表达式 /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i
 15位校验规则 6位地址编码+6位出生日期+3位顺序号
 18位校验规则 6位地址编码+8位出生日期+3位顺序号+1位校验位

 校验位规则     公式:∑(ai×Wi)(mod 11)……………………………………(1)
 公式(1)中：
 i----表示号码字符从右至左包括校验码在内的位置序号；
 ai----表示第i位置上的号码字符值；
 Wi----表示第i位置上的加权因子，其数值依据公式Wi=2^(n-1）(mod 11)计算得出。
 i 18 17 16 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1
 Wi 7 9 10 5 8 4 2 1 6 3 7 9 10 5 8 4 2 1

 身份证在线生成器：http://www.welefen.com/lab/identify

 */
export const Identification = {
  vcity: {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外',
  },
  arrInt: [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
  arrCh: ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'],
  //检查号码是否符合规范，包括长度，类型
  isCardNo(card) {
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    let reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
    return reg.test(card);
  },
  //取身份证前两位,校验省份
  checkProvince(card) {
    let province = card.substr(0, 2);
    return this.vcity[province];
  },
  //检查生日是否正确
  checkBirthday(card) {
    const len = card.length;
    let re_fifteen, re_eighteen, arr_data, year, month, day, birthday;
    //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len === 15) {
      re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
      arr_data = card.match(re_fifteen);
      year = arr_data[2];
      month = arr_data[3];
      day = arr_data[4];
      birthday = new Date('19' + year + '/' + month + '/' + day);
      return this.verifyBirthday('19' + year, month, day, birthday);
    }
    //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len === 18) {
      re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
      arr_data = card.match(re_eighteen);
      year = arr_data[2];
      month = arr_data[3];
      day = arr_data[4];
      birthday = new Date(year + '/' + month + '/' + day);
      return this.verifyBirthday(year, month, day, birthday);
    }
    return false;
  },

  //校验日期,这个可以校验2月31这种不合理的情况
  verifyBirthday(year, month, day, birthday) {
    const now = new Date();
    const now_year = now.getFullYear();
    //年月日是否合理
    if (birthday.getFullYear() == year && birthday.getMonth() + 1 == month && birthday.getDate() == day) {
      //判断年份的范围（0岁到200岁之间)
      let time = now_year - year;
      return time >= 0 && time <= 200;
    }
    return false;
  },

  //校验位的检测
  checkParity(card) {
    card = this.changeFifteenToEighteen(card); //15位转18位
    const len = card.length;
    if (len === 18) {
      let arrInt = this.arrInt;
      let arrCh = this.arrCh;
      let cardTemp = 0,
        i,
        valnum;
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[cardTemp % 11];
      return valnum == card.substr(17, 1);
    }
    return false;
  },
  //15位转18位身份证号
  changeFifteenToEighteen(card) {
    if (card.length === 15) {
      let arrInt = this.arrInt;
      let arrCh = this.arrCh;
      let cardTemp = 0,
        i;
      card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      card += arrCh[cardTemp % 11];
      return card;
    }
    return card;
  },
  isID(card) {
    card = card.toUpperCase();
    let message = {};
    //是否为空
    if (card === '') {
      message = {
        message: '身份证号不能为空',
        result: false,
      };
    }
    if (this.isCardNo(card) && this.checkProvince(card) && this.checkBirthday(card) && this.checkParity(card)) {
      message = {
        message: 'ok',
        result: true,
      };
    } else {
      message = {
        message: '身份证填写有误',
        result: false,
      };
    }

    return message;
  },
};

export function getBirthFromIDCard(idCard) {
  let birthday;
  let birthYearSpan = idCard.length === 15 ? 2 : 4;
  let year = (birthYearSpan === 2 ? '19' : '') + idCard.substr(6, birthYearSpan);
  let month = idCard.substr(6 + birthYearSpan, 2);
  let day = idCard.substr(8 + birthYearSpan, 2);
  birthday = year + '-' + month + '-' + day;
  return birthday;
}

export function getAgeFromBirth(date) {
  const now = new Date();
  const ny = Number(now.getFullYear());
  const old = new Date(date);
  const oy = Number(old.getFullYear());

  return ny - oy;
}

export function getBirthFromAge(age) {
  const y = Dayjs(new Date()).add(age, 'year').year();
  return `${y}-01-01`;
}

export function getSexFromIDCard(idCard) {
  let sexStr = '';
  if (parseInt(idCard.slice(-2, -1)) % 2 === 1) {
    sexStr = '1'; // 男
  } else {
    sexStr = '2'; // 女
  }
  return sexStr;
}

const Verify = {
  phone: phone,
  name: name,
};

export default Verify;
